import React, {useContext, useEffect, useMemo, useState} from "react";
import "./index.scss";
import {strings} from "../../../strings/strings";
import {default as axios} from "../../../api/axiosConfig";
import config, {axiosConfig} from "../../../config";
import {ProcessingContext} from "../../../contexts/ProcessingContext";
import {Form, Formik} from "formik";
import {TextField} from "@material-ui/core";
import {Button} from "../../Button";
import {useHistory, useLocation} from "react-router-dom";

export const ContractCheckContent = () => {
    const {setProcessingOpen} = useContext(ProcessingContext);
    const [response, setResponse] = useState(null);
    const location = useLocation();
    const [currentContractId, setCurrentContractId]
        = useState(new URLSearchParams(location.search).get('contractId')?.replace('?', ''));
    const [textFieldValue, setTextFieldValue] = useState('');
    const history = useHistory();
    const contractStatuses = {
        SIGNED: 'Зареєстрований',
        ACTIVE: 'Діючий',
        CANCELED: 'Не Діючий',
        CANCELED_DUE_TO_PAYMENT: "Не Діючий"
    }

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.has("contractId") || currentContractId) {
            history.push(`check?contractId=${currentContractId}`);
        }
    }, [currentContractId]);

    useEffect(() => {
        if (currentContractId) {
            setProcessingOpen(true);
            fetchContractByNumber(currentContractId).then(resp => {
                setResponse(resp);
            }).catch(err => handleException())
                .finally(() => {
                    setProcessingOpen(false);
                });
        }
    }, [currentContractId]);

    useEffect(() => {
        if (textFieldValue !== currentContractId) {
            setTextFieldValue(currentContractId);
        }
    }, [response]);

    async function fetchContractByNumber(contractNumber: string) {
        const data = await axios.get(`${config.API_URL}/contract-check?number=${contractNumber}`, axiosConfig);
        return data;
    }

    function handleOnChange(event) {
        setTextFieldValue(event.target.value.trim());
    }

    function handleException() {
        setResponse({status: 404});
    }

    const responseBorderClassName = useMemo(() => {
        if (!response || response.status !== 200) return "";
        const statusClassMap = {
            ACTIVE: "response-success__border-green",
            SIGNED: "response-success__border-gray",
        };
        return statusClassMap[response.data["STATUS"]] || "response-success__border-red";
    }, [response]);

    const responseButtonClassName = useMemo(() => {
        if (!response || response.status !== 200) return "";
        const statusClassMap = {
            ACTIVE: "response-success__status-row__button-green",
            SIGNED: "response-success__status-row__button-gray",
        };
        return statusClassMap[response.data["STATUS"]] || "response-success__status-row__button-red";
    }, [response]);

    return (
        <div className="container">
            <h3 className={'mb-50'}>{strings.checkDetails}</h3>
            <div className="check-form">
                <Formik
                    initialValues={{}}
                    onSubmit={(values, {setSubmitting}) => {
                        setSubmitting(false);
                        if (textFieldValue && textFieldValue != currentContractId) {
                            setCurrentContractId(textFieldValue);
                        }
                    }}
                >
                    <Form>
                        <div className='text-field'>
                            <TextField label='Номер полісу' value={textFieldValue} variant='outlined' fullWidth={true}
                                       autoFocus type='text'
                                       onChange={event => handleOnChange(event)}
                            />
                        </div>
                        <Button type='submit' label={strings.findContract}/>
                    </Form>
                </Formik>
            </div>


            <div className="check-response">
                {response && (response.status === 200
                    ? <div className={`response-success ${responseBorderClassName}`}>
                        <div className="response-success__contract">Ваш поліс {currentContractId}</div>
                            <div className="response-success__status-row">
                                <div className="response-success__status-row__title gray-text">Статус договору:</div>
                                    <div className={`response-success__status-row__button ${responseButtonClassName}`}>
                                        <span className="response-success__status-row__green-button__text">
                                            {contractStatuses[response.data['STATUS']]}
                                        </span>
                                    </div>
                                </div>

                                <div className="response-success__data">
                                    {Object.entries(response.data).map(([key, value]) => {
                                        if (key !== 'STATUS') {
                                            return <div className="response-success__data__row" key={key}>
                                                <div className="response-success__data__row-name gray-text">{key}:</div>
                                                <div
                                                    className="response-success__data__row-value black-text">{value}
                                                </div>
                                            </div>;
                                        }
                                    })}
                                </div>
                            </div>
                    : <div className="response-fail">
                        <div className="response-fail__title">Договір не зареєстрований у системі</div>
                            <div className="response-fail__message">Перевірте, будь ласка, правильність введених даних.
                                    Для уточнення інформації можна звернутися до контакт-центру за телефоном <div
                                        className="response-fail__tel">0 800 30 27 23</div>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    );
};
